import React, { Fragment, memo } from 'react'

import Width from 'components/_old/Width/Width'

import { Paper } from 'components/atoms/Paper'

import { Title, ProviderInput, PlanNumber, Amount, PartType, AssetTransferType } from './index'

const RequestForm = memo(() => {
  return (
    <Fragment>
      <Title />
      <Width size={22.5}>
        <Paper top={24}>
          <ProviderInput />
          <PlanNumber />
        </Paper>
        <Paper top={16}>
          <Amount />
        </Paper>
        <Paper top={24}>
          <PartType />
        </Paper>
        <Paper top={24}>
          <AssetTransferType />
        </Paper>
      </Width>
    </Fragment>
  )
})
RequestForm.displayName = 'RequestForm'

export { RequestForm }
